import { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';

export default (reloadTabCallback, tabId, deps) => {

    const dateSelection = useSelector(({ overview }) => overview.dateSelection);
    const activeTab = useSelector(({ operationalParameters }) => operationalParameters.activeTab);

    const [date, setDate] = useState(dateSelection);

    useEffect(() => {
        const dateChanged = date?.from !== dateSelection?.from
            || date?.to !== dateSelection?.to;
        if (activeTab === tabId && dateChanged) {
            setDate(dateSelection);
            reloadTabCallback();
        }
    }, [dateSelection, activeTab]);

    // Run reload when deps change, but skip the first invocation to avoid
    // triggering a reload on mount (prevents race conditions when other
    // state updates are still being applied).
    const mountedRef = useRef(false);
    deps && useEffect(() => {
        if (!mountedRef.current) {
            mountedRef.current = true;
            return;
        }
        reloadTabCallback();
    }, [...deps]);
};
